import * as React from "react"
import ReactPlayer from "react-player"

const config = {
    youtube: {
        playerVars: { 
            showinfo: 0,
            autoplay: true,
            loop: 1
        }
      }  
}
function MCDemo(props) {

    config.youtube.playerVars.playlist = [props.video_demo_1, props.video_demo_1, props.video_demo_1]

    return (<div className="flex flex-row items-centermb-36" style={{backgroundColor:"#1B1B1B"}}>
                <div className="h-full flex-1">
                <ReactPlayer playing={true} loop={true} volume={0} muted={true} controls={false} url={props.video_demo_1} />

                </div>
                <div className="h-full  flex-1">
                <ReactPlayer playing={true} loop={true} volume={0}  muted={true} controls={false} url={props.video_demo_2} />

                </div>
            </div>)
}

export default MCDemo